import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const en = {
  nav: {
    Dashboard: "Dashboard", Jobs: "Jobs", Map: "Map", Requests: "Requests", Messages: "Messages",
    Bids: "Bids", "Price Book": "Price Book", Pricing: "Pricing", Crew: "Crew", Clients: "Clients",
    Training: "Training", Archived: "Archived", "Admin Guide": "Admin Guide", "My Work": "My Work",
    "My Jobs": "My Jobs", "My Requests": "My Requests", Prices: "Prices", "My Profile": "My Profile",
    Checklists: "Checklists", "My Pay Rates": "My Pay Rates",
  },
  common: {
    logout: "Log out", shareApp: "Share app", save: "Save", saving: "Saving…", cancel: "Cancel",
    delete: "Delete", edit: "Edit", add: "Add", search: "Search", loading: "Loading…",
    start: "Start", back: "Back", language: "Language", none: "None",
  },
  login: {
    chooseRole: "Choose how you'd like to continue", client: "Client", contractor: "Contractor",
    clientDesc: "Request & track property-preservation services",
    contractorDesc: "Get assigned jobs, submit bids & upload photos",
    continueGoogle: "Continue with Google", signIn: "Sign in", createAccount: "Create account",
    email: "Email", password: "Password", fullName: "Full name", forgotPassword: "Forgot password?",
    howItWorks: "How it works",
  },
  training: {
    title: "Training", academy: "Field Academy",
    subtitle: "How to perform each task to client specification.",
    addModule: "Add Module", allTraining: "All training", noModules: "No training modules yet.",
    translateAll: "Translate missing to Spanish",
  },
  pricing: {
    title: "Pricing", subtitle: "Per-client price sheets and the contractor pay sheet.",
    clientSheets: "Client Price Sheets", paySheet: "Contractor Pay Sheet", newSheet: "New Sheet",
    uploadSheet: "Upload Sheet", service: "Service", category: "Category", unit: "Unit",
    clientPrice: "Client Price", allowableCap: "Allowable cap", contractorPay: "Contractor Pay",
    byBid: "By bid", payType: "Pay type", percentOfClient: "% of client price", fixedAmount: "Fixed $",
    defaultRule: "Default (all other services)", addRule: "Add rule", addRow: "Add row",
    sheetNote: "Each price is the billable amount and the contractor's allowable cap.",
    payNote: "Contractor pay = fixed $ or % of the client price, always capped at the allowable.",
    uploadHint: "Upload a .csv, .xlsx or .pdf price sheet — rows are added to this sheet.",
    jobSheet: "Client Price Sheet", yourPay: "Your pay", clientBillable: "Client billable",
  },
  dashboard: { eyebrow: "Command Center", title: "Dashboard", announce: "Send Announcement", totalJobs: "Total Jobs", newRequests: "New Requests", crewMembers: "Crew Members", overdue: "Overdue", today: "Today", bidPipeline: "Bid Pipeline", nothingToday: "Nothing scheduled today.", allCaught: "All caught up.", loading: "Loading dashboard…" },
  jobsPage: { allProps: "All Properties", assignedWork: "Assigned Work", archive: "Archive", title: "Jobs", archivedTitle: "Archived Jobs", importCrm: "Import CRM File", newJob: "New Job", search: "Search address, client…", none: "No jobs found.", all: "All", priceSheet: "Client Price Sheet (sets allowable)", payout: "Payout" },
  bidsPage: { eyebrow: "Estimator / Bid Builder", title: "Bids", newBid: "New Bid" },
  crewPage: { eyebrow: "Team", title: "Crew", add: "Add Contractor", import: "Import", email: "Email Contractors", launch: "Launch Email", search: "Search by name, email, company, ZIP, county or service…", all: "All", available: "Available now", coverageMap: "Coverage Map", hideMap: "Hide Map", none: "No contractors yet." },
  status: { active: "active", in_progress: "in progress", completed: "completed", draft: "Draft", sent: "Sent", approved: "Approved", declined: "Declined" },
};

const es = {
  nav: {
    Dashboard: "Panel", Jobs: "Trabajos", Map: "Mapa", Requests: "Solicitudes", Messages: "Mensajes",
    Bids: "Presupuestos", "Price Book": "Lista de Precios", Pricing: "Precios", Crew: "Cuadrilla",
    Clients: "Clientes", Training: "Capacitación", Archived: "Archivados", "Admin Guide": "Guía del Admin",
    "My Work": "Mi Trabajo", "My Jobs": "Mis Trabajos", "My Requests": "Mis Solicitudes",
    Prices: "Precios", "My Profile": "Mi Perfil",
    Checklists: "Listas de Control", "My Pay Rates": "Mis Tarifas",
  },
  common: {
    logout: "Cerrar sesión", shareApp: "Compartir app", save: "Guardar", saving: "Guardando…",
    cancel: "Cancelar", delete: "Eliminar", edit: "Editar", add: "Agregar", search: "Buscar",
    loading: "Cargando…", start: "Comenzar", back: "Atrás", language: "Idioma", none: "Ninguno",
  },
  login: {
    chooseRole: "Elige cómo deseas continuar", client: "Cliente", contractor: "Contratista",
    clientDesc: "Solicita y haz seguimiento de servicios de preservación de propiedades",
    contractorDesc: "Recibe trabajos asignados, envía ofertas y sube fotos",
    continueGoogle: "Continuar con Google", signIn: "Iniciar sesión", createAccount: "Crear cuenta",
    email: "Correo electrónico", password: "Contraseña", fullName: "Nombre completo",
    forgotPassword: "¿Olvidaste tu contraseña?", howItWorks: "Cómo funciona",
  },
  training: {
    title: "Capacitación", academy: "Academia de Campo",
    subtitle: "Cómo realizar cada tarea según la especificación del cliente.",
    addModule: "Agregar Módulo", allTraining: "Toda la capacitación", noModules: "Aún no hay módulos de capacitación.",
    translateAll: "Traducir faltantes al español",
  },
  pricing: {
    title: "Precios", subtitle: "Listas de precios por cliente y la hoja de pago del contratista.",
    clientSheets: "Listas de Precios por Cliente", paySheet: "Hoja de Pago del Contratista",
    newSheet: "Nueva Lista", uploadSheet: "Subir Lista", service: "Servicio", category: "Categoría",
    unit: "Unidad", clientPrice: "Precio Cliente", allowableCap: "Tope permitido",
    contractorPay: "Pago Contratista", byBid: "Por oferta", payType: "Tipo de pago",
    percentOfClient: "% del precio cliente", fixedAmount: "$ fijo",
    defaultRule: "Predeterminado (todos los demás servicios)", addRule: "Agregar regla", addRow: "Agregar fila",
    sheetNote: "Cada precio es el monto facturable y el tope permitido para el contratista.",
    payNote: "Pago del contratista = $ fijo o % del precio del cliente, siempre con tope en lo permitido.",
    uploadHint: "Sube una lista de precios .csv, .xlsx o .pdf — las filas se agregan a esta lista.",
    jobSheet: "Lista de Precios del Cliente", yourPay: "Tu pago", clientBillable: "Facturable al cliente",
  },
  dashboard: { eyebrow: "Centro de Mando", title: "Panel", announce: "Enviar Anuncio", totalJobs: "Trabajos Totales", newRequests: "Nuevas Solicitudes", crewMembers: "Miembros de Cuadrilla", overdue: "Atrasados", today: "Hoy", bidPipeline: "Flujo de Presupuestos", nothingToday: "Nada programado para hoy.", allCaught: "Todo al día.", loading: "Cargando panel…" },
  jobsPage: { allProps: "Todas las Propiedades", assignedWork: "Trabajo Asignado", archive: "Archivo", title: "Trabajos", archivedTitle: "Trabajos Archivados", importCrm: "Importar Archivo CRM", newJob: "Nuevo Trabajo", search: "Buscar dirección, cliente…", none: "No se encontraron trabajos.", all: "Todos", priceSheet: "Lista de Precios del Cliente (define el tope)", payout: "Pago" },
  bidsPage: { eyebrow: "Estimador / Generador de Presupuestos", title: "Presupuestos", newBid: "Nuevo Presupuesto" },
  crewPage: { eyebrow: "Equipo", title: "Cuadrilla", add: "Agregar Contratista", import: "Importar", email: "Correo a Contratistas", launch: "Correo de Lanzamiento", search: "Buscar por nombre, correo, empresa, código postal, condado o servicio…", all: "Todos", available: "Disponible ahora", coverageMap: "Mapa de Cobertura", hideMap: "Ocultar Mapa", none: "Aún no hay contratistas." },
  status: { active: "activo", in_progress: "en progreso", completed: "completado", draft: "Borrador", sent: "Enviado", approved: "Aprobado", declined: "Rechazado" },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es } },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    detection: { order: ["localStorage", "navigator"], lookupLocalStorage: "ss_lang", caches: ["localStorage"] },
    interpolation: { escapeValue: false },
  });

export default i18n;
